import type {
  FilterFunc,
  FilterState,
  FilterType,
} from "@/components/controls/grid/columnfilters/ColumnFilters";
import { buildApplyFilter } from "@/components/controls/grid/columnfilters/ColumnFilters";

export const numberFilterTypes: FilterType[] = [
  {
    type: "filter_equals",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: number | null
    ) =>
      filterValue != null
        ? !isNaN(Number(itemValue)) && Number(itemValue) === filterValue
        : true,
  },
  {
    type: "filter_not_equals",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: number | null
    ) =>
      filterValue != null
        ? !isNaN(Number(itemValue)) && Number(itemValue) !== filterValue
        : true,
  },
  {
    type: "filter_greater_than",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: number | null
    ) =>
      filterValue != null
        ? !isNaN(Number(itemValue)) && Number(itemValue) > filterValue
        : true,
  },
  {
    type: "filter_less_than",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: number | null
    ) =>
      filterValue != null
        ? !isNaN(Number(itemValue)) && Number(itemValue) < filterValue
        : true,
  },
];

export function buildApplyNumberFilter(state: FilterState): FilterFunc {
  return buildApplyFilter(state, numberFilterTypes);
}
